import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import { TemplateResult, html, nothing } from 'lit';
import {
  FeatureValue, HistoryConsentItem, HistoryItem, PredecessorItem,
} from '@mfe-4cs/types/comsApi';
import { featuresTypes } from '@mfe-4cs/defs/featureTypes';
import { comsStore } from '@mfe-4cs/state/ComsStore';
import { localDate, localTime } from '../util';

const labelTmpl = (granted: boolean) => {
  const status = granted ? 'approved' : 'rejected';
  const text = granted ? 'Zustimmung' : 'Widerspruch';

  return html`
    <span class="history-status history-status--${status}">
      ${text}
    </span>
  `;
};

const featureTmpl = (feature: FeatureValue) => html`
  <div class="row">
    <div class="col">${feature.title}</div>
    <div class="col">${labelTmpl(!!feature.granted)}</div>
  </div>
`;

// eslint-disable-next-line sonarjs/function-return-type
const predeseccorsTemplate = (predecessors?: PredecessorItem[]) => {
  if (!predecessors) {
    return nothing;
  }

  return html`
    <div>
        Vorgänger: ${predecessors.map(({ id, name }, ind) => html`
          ${ind > 0 ? ' und ' : nothing}
          <a
            role="button"
            @click=${() => { /* eslint-disable @typescript-eslint/indent */
              comsStore.history!.configId = id;
            } /* eslint-enable @typescript-eslint/indent */}
          >
            ${name}
          </a>
        `)}
    </div>
  `;
};

const historyConsentItem = (coms: HistoryConsentItem): TemplateResult => {
  const existingFeatureName = featuresTypes.find((fn) => !!coms[fn]);

  const feats = existingFeatureName ? coms[existingFeatureName] : [];

  return html`
      ${labelTmpl(coms.granted)}
      <div>${feats!.map(featureTmpl)}</div>
      <span class="history-changed">
         <tef-coms-icon icon="clock" context="selfcare selfcare" size="m" type="default"></tef-coms-icon>
         Geändert von ${coms.meta.usertype}: ${coms.meta.username} über ${coms.meta.channelDisplay};  Version ${coms.version}
         ${predeseccorsTemplate(coms.meta.predecessors)}
      </span>
  `;
};

export function historyItemTemplate(this: TefComs4csMicroFrontend, item: HistoryItem): TemplateResult {
  return html`
    <div class="history-entry">
      <p>
        <span class="history-timestamp">
          ${localDate(item.actionDate)} ${localTime(item.actionDate)}
        </span>
      </p>
      ${item.consents.map(historyConsentItem)}
    </div>
  `;
}
